import { FallthroughKpiCard } from './FallthroughKpiCard';
import { FcrKpiCard } from './FcrKpiCard';
import { FeedVsPlanKpiCard } from './FeedVsPlanKpiCard';
import type { KpiCardProps } from './kpiCardFormat';
import { RgiKpiCard } from './RgiKpiCard';
import { WeightKpiCard } from './WeightKpiCard';

interface FeedingKpiRowProps extends KpiCardProps {
    /** The pellet flag and the hardware together; the view owns that rule for the page. */
    showFallthrough: boolean;
}

export function FeedingKpiRow(props: FeedingKpiRowProps) {
    const { showFallthrough, ...cardProps } = props;

    return (
        <>
            <WeightKpiCard {...cardProps} />
            <FcrKpiCard {...cardProps} />
            <RgiKpiCard {...cardProps} />
            <FeedVsPlanKpiCard {...cardProps} />
            {/* Pellet fallthrough needs the flag and a feeding camera, so the card is
                absent entirely without either rather than showing a permanent dash
                (IPS req 26 and 27). */}
            {showFallthrough ? <FallthroughKpiCard {...cardProps} /> : null}
        </>
    );
}
